import { LayoutHeader2 } from "../components/Interactions/LayoutHeader2";
import WhatsAppTemplatesList from "../components/WhatsAppTemplates";

export const WhatsAppTemplates: React.FC = () => {
  return (
    <LayoutHeader2>
      <WhatsAppTemplatesList />
    </LayoutHeader2>
  );
};
